import axios from 'axios';
// config
import { HOST_API } from '../config';
import {store} from '../redux/store'
import {setAdminHasAccess, setUserRole} from "../redux/slices/user";
import {setLoader} from "../redux/slices/common";
import ReactGA from "react-ga4"
import { BLOCKED_ROLE_UUID } from 'src/constants/user-role-constants';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

axiosInstance.interceptors.request.use((config) => {
  /** In dev, intercepts request and logs it into console for dev */
  //ReactGA.event({category: "Request", action: "post", label: "TestToDo - Start"})
  ReactGA.event({category: "Request", action: config.method, label: config.url})
  return config;
}, (error) => {
  ReactGA.event({category: "Request-Error", action: config.method, label: config.url})
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
  (response) => {
    ReactGA.event({category: "Response", action: response.config.method, label: response.config.url})
    return response
  },
  (error) => {
      ReactGA.event({category: "Response-Error", action: error.config.method, label: error.config.url})
      if (error?.response?.status === 403 && error?.response?.data.message.includes("Not authorized")) {
          store.dispatch(setAdminHasAccess(false))
      } else if (error?.response?.status === 403) {
          store.dispatch(setUserRole(BLOCKED_ROLE_UUID))
      }
      store.dispatch(setLoader(false))
      if (error.response.status === 406) {
          return Promise.reject(error)
      }
    return Promise.reject((error.response && error.response.data) || 'Something went wrong')
  }
);

export default axiosInstance;
